import { render, staticRenderFns } from "./OrderDetailView.vue?vue&type=template&id=d7791f48&scoped=true&"
import script from "./OrderDetailView.vue?vue&type=script&lang=ts&"
export * from "./OrderDetailView.vue?vue&type=script&lang=ts&"
import style0 from "./OrderDetailView.vue?vue&type=style&index=0&id=d7791f48&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7791f48",
  null
  
)

export default component.exports